import { FC } from 'react';

export const AuthenticatedRoute: FC<React.PropsWithChildren<unknown>> = ({ children }) => {
  return <>{children}</>;
};
